import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
@Component({
  selector: 'app-planned-actual',
  templateUrl: './planned-actual.component.html',
  styleUrls: ['./planned-actual.component.css']
})
export class PlannedActualComponent implements OnInit {
  public employeelistarr: any = [];
  public filteredOptions: Observable<string[]>;
  public selectedempno: any;
  public projectList: any = [];
  public showTable = false;
  public planned: any;
  public value: any = [];
  public total = 0;
  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/planned-actual/planned-actual.component.ts